module HistoryModal {
  let historyModal = $("#HistoryModal");
  let historyModalBody = $("#HistoryModalBody");

  export function construct() {
    historyModal = $("#HistoryModal");
    historyModalBody = $("#HistoryModalBody");
  }

  export function showHistoryForColumn(columnId: string, rowId: number): void {
    HistoryTableFactory.GetByColumn(columnId, rowId, showModal);
  }

  export function showHistoryForTable(tableId: string, rowId: number): void {
    HistoryTableFactory.GetByTable(tableId, rowId, showModal);
  }

  function showModal(html: string): void {
    historyModalBody.html(html);
    historyModal.modal("show");
  }
}

$(document).ready(() => { HistoryModal.construct(); });